import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Zap } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Marqi Rank', href: '/rank' },
        { name: 'Marqi Cast', href: '/cast' },
        { name: 'Marqi Ops', href: '/ops' }
      ]
    },
    {
      title: 'Pricing',
      links: [
        { name: 'Ops Pricing', href: '/ops/pricing' },
        { name: 'Rank Pricing', href: '/rank/pricing' },
        { name: 'Cast Pricing', href: '/cast/pricing' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Blog', href: '/blog' },
        { name: 'About Us', href: '/about' },
        { name: 'Contact', href: '/contact' },
        { name: 'Privacy Policy', href: '/privacy' }
      ]
    }
  ];

  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-[var(--border-subtle)] mt-24">
      <div className="container">
        <div className="py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-16">
            {/* Brand Section */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center space-x-2 mb-6">
                <div className="relative">
                  <span className="text-2xl font-bold text-white">Marqi</span>
                  <Zap className="inline-block w-5 h-5 text-[var(--accent-primary)] ml-1" />
                </div>
              </Link>
              <p className="text-[var(--text-secondary)] mb-8 max-w-md">
                The discoverability partner for SMB agencies — AI search visibility and streaming TV,
                fully white-labeled, under your brand.
              </p>
              
              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-[var(--accent-primary)]" />
                  <span className="text-[var(--text-secondary)]">hello@marqi.io</span>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="w-5 h-5 text-[var(--accent-primary)]" />
                  <span className="text-[var(--text-secondary)]">Global — US · UK · AU · CA and growing</span>
                </div>
              </div>
            </div>

            {/* Footer Links */}
            {footerSections.map((section) => (
              <div key={section.title}>
                <h3 className="text-[var(--text-primary)] font-semibold mb-6">{section.title}</h3>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.href}
                        className="text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="py-8 border-t border-[var(--border-subtle)] flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-[var(--text-muted)]">
            © {currentYear} Marqi. All rights reserved. · Global service · Locally relevant
          </p>
          
          {/* Social Links Removed */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;